import { TRANSACTION_STATUS_LABEL } from 'src/app/features/feature-transaction-rules/search-result/index.constant'
import {
  EPermissions,
  ESubModules,
  IUserPermissions,
} from 'src/app/shared/models/roleAndPermission.model'

export enum ETransactionAction {
  EDIT = 'EDIT',
  DELETE = 'DELETE',
  VOID = 'VOID',
}

const STATUS_ALLOWLIST_BY_ACTION: Partial<Record<ETransactionAction, TRANSACTION_STATUS_LABEL[]>> = {
  [ETransactionAction.EDIT]: [TRANSACTION_STATUS_LABEL.ISSUED],
  [ETransactionAction.DELETE]: [TRANSACTION_STATUS_LABEL.ISSUED, TRANSACTION_STATUS_LABEL.VOID],
}

// VOID usa denylist para preservar comportamento legado (permite Outstanding/Stop Payment, fora do escopo da US29739)
const STATUS_DENYLIST_FOR_VOID: TRANSACTION_STATUS_LABEL[] = [
  TRANSACTION_STATUS_LABEL.VOID,
  TRANSACTION_STATUS_LABEL.EXCEPTION,
  TRANSACTION_STATUS_LABEL.RETURNED,
  TRANSACTION_STATUS_LABEL.PAID,
]

export const isStatusAllowedForAction = (
  status: string | undefined,
  action: ETransactionAction,
): boolean => {
  if (!status) return false
  if (action === ETransactionAction.VOID) {
    return !STATUS_DENYLIST_FOR_VOID.includes(status as TRANSACTION_STATUS_LABEL)
  }
  return STATUS_ALLOWLIST_BY_ACTION[action]?.includes(status as TRANSACTION_STATUS_LABEL) ?? false
}

export const hasPermission = (
  userPermissions: IUserPermissions,
  subModule: ESubModules,
  permission: EPermissions,
): boolean => {
  return Boolean(userPermissions[subModule]?.includes(permission))
}

interface CanPerformTransactionActionParams {
  rowData: { status?: string; transactionType?: string } | null | undefined
  action: ETransactionAction
  userPermissions: IUserPermissions
  subModule: ESubModules
  permission: EPermissions
}

export const canPerformTransactionAction = ({
  rowData,
  action,
  userPermissions,
  subModule,
  permission,
}: CanPerformTransactionActionParams): boolean => {
  if (!rowData) return false
  if (rowData.transactionType !== 'Check') return false
  if (!isStatusAllowedForAction(rowData.status, action)) return false
  return hasPermission(userPermissions, subModule, permission)
}
